////ドロワー
$(function () {
    $(".switch-btn").on("click", function () {
        $(this).toggleClass('active');
        $('.global-nav').toggleClass('active');
        return false;
    });

    // ▼ ページ内リンククリック時にメニューを閉じる
    $('.global-nav a[href^="#"]').on('click', function () {
        // メニューを閉じる
        $('.switch-btn').removeClass('active');
        $('.global-nav').removeClass('active');
    });
});




// フェードイン
$(window).scroll(function () {
    $('.fadeUp').each(function () {
        var elemPos = $(this).offset().top,
            scroll = $(window).scrollTop(),
            windowHeight = $(window).height();

        if (scroll > elemPos - windowHeight + 150) {
            $(this).addClass('scrollin');
        }
    });
});


//　スクロール
$(function () {
    $('a[href^="#"]').click(function () {
        var adjust = -100;
        var speed = 500;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top + adjust;
        $("html, body").animate({ scrollTop: position }, speed, "swing");
        return false;
    });
});

$(function () {
    // 別ページの場合は以下
    var urlHash = location.hash;
    if (urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function () {
            if (window.matchMedia("(max-width: 1024px)").matches) {
                var headerHight = 80;

            } else {
                var headerHight = 100;
            }
            var target = $(urlHash);
            var position = target.offset().top - headerHight;
            $('body,html').stop().animate({ scrollTop: position }, 500);
        }, 100);
    }
});




const lenis = new Lenis()

function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
}
requestAnimationFrame(raf)

// ページ内の画像が全部読み込まれた時に高さを補正
window.addEventListener('load', () => {
    lenis.resize()
})



//ヘッダーのカートの数字
function updateCartCount(cart) {
    const countElem = document.querySelector('.cart-count');
    if (!countElem) return;

    const previous = parseInt(countElem.textContent) || 0;
    const current = cart.item_count;

    countElem.textContent = current;
    countElem.style.display = current > 0 ? 'flex' : 'none';

    // 数字が変わったときにアニメーション
    if (current !== previous) {
        countElem.classList.add('bump');
        setTimeout(() => countElem.classList.remove('bump'), 300);
    }
}

// 初回ロード時にカート取得
fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => updateCartCount(cart));

// Ajaxでカート更新したときに呼ぶ例
document.addEventListener('cart:updated', (e) => {
    // e.detail.cart が更新後のカート情報と仮定
    updateCartCount(e.detail.cart);
});




